import { createNoise3D, type NoiseFunction3D } from "simplex-noise"
import { createNewRNGConfig, next } from "./index"

export default function createSeededNoise3D(seed: number): NoiseFunction3D {
  const rng = createNewRNGConfig()
  rng.seed = rng.state = seed
  const noise3D = createNoise3D(() => next(rng))
  return noise3D
}